export default "__VITE_ASSET__DdpCQpqD__"